import { QueryDocumentSnapshot } from 'firebase/firestore';
import { Model } from '../../model/Model';
import { IModelDataConverter } from '../IModelDataConverter';

export class ModelDataConverter<T extends Model> implements IModelDataConverter<T> {
  toFirestore(model: T) {
    const data = { ...model };
    delete data.id;
    return data;
  }

  fromFirestore(snapshot: QueryDocumentSnapshot) {
    const model = snapshot.data() as T;
    model.id = snapshot.id;
    return model;
  }
}